import { Link } from 'react-router-dom';
import { Instagram, Twitter, Youtube, Facebook } from 'lucide-react';
import Logo from './Logo';

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="mt-32 border-t border-border">
      {/* Newsletter */}
      <div className="container py-24 grid gap-12 md:grid-cols-2 items-end">
        <div>
          <p className="overline text-muted-foreground">Letters, seldom sent</p>
          <h2 className="mt-4 font-display text-5xl md:text-6xl tracking-tight leading-none">
            Notes from the mountain.
          </h2>
        </div>
        <form
          className="flex items-end gap-4 border-b border-foreground pb-3"
          onSubmit={(e) => { e.preventDefault(); e.currentTarget.reset(); alert('Subscribed. Look for our next dispatch.'); }}
          data-testid="newsletter-form"
        >
          <label className="sr-only" htmlFor="newsletter-email">Email address</label>
          <input
            id="newsletter-email"
            data-testid="newsletter-email-input"
            type="email"
            required
            placeholder="Your email"
            className="flex-1 bg-transparent outline-none placeholder:text-muted-foreground text-lg py-2"
          />
          <button type="submit" data-testid="newsletter-submit" className="overline link-underline">Subscribe</button>
        </form>
      </div>

      <div className="brushline mx-6 md:mx-12" />

      <div className="container py-16 grid gap-12 md:grid-cols-5">
        <div className="md:col-span-2">
          <Logo />
          <p className="mt-6 text-sm text-muted-foreground max-w-xs leading-relaxed">
            Considered clothing for every day. Designed for everyday confidence.
          </p>
          <div className="mt-8 flex items-center gap-4">
            {[
              { href: 'https://instagram.com', label: 'Instagram', Icon: Instagram },
              { href: 'https://twitter.com', label: 'Twitter', Icon: Twitter },
              { href: 'https://youtube.com', label: 'YouTube', Icon: Youtube },
              { href: 'https://facebook.com', label: 'Facebook', Icon: Facebook },
            ].map(({ href, label, Icon }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noreferrer noopener"
                aria-label={label}
                data-testid={`social-${label.toLowerCase()}`}
                className="h-10 w-10 border border-border inline-flex items-center justify-center hover:border-foreground transition-colors duration-500"
              >
                <Icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>
        <FooterCol title="Shop" links={[
          { to: '/shop/men', label: 'Men' },
          { to: '/shop/women', label: 'Women' },
          { to: '/shop/kids', label: 'Kids' },
          { to: '/shop/accessories', label: 'Accessories' },
          { to: '/shop/new-arrivals', label: 'New Arrivals' },
          { to: '/shop/sale', label: 'Sale' },
        ]} />
        <FooterCol title="House" links={[
          { to: '/about', label: 'About' },
          { to: '/blog', label: 'Journal' },
          { to: '/lookbook', label: 'Lookbook' },
          { to: '/contact', label: 'Contact' },
          { to: '/faq', label: 'FAQ' },
        ]} />
        <FooterCol title="Policies" links={[
          { to: '/policies/shipping', label: 'Shipping' },
          { to: '/policies/returns', label: 'Returns' },
          { to: '/policies/privacy', label: 'Privacy' },
          { to: '/policies/terms', label: 'Terms' },
          { to: '/policies/cookies', label: 'Cookies' },
        ]} />
      </div>

      <div className="container flex flex-col md:flex-row items-center justify-between gap-6 border-t border-border py-8">
        <p className="overline text-muted-foreground">© {new Date().getFullYear()} Evermark — A Legacy in Every Mark</p>
        <div className="flex items-center gap-6 overline text-muted-foreground">
          <Link to="/policies/privacy" className="link-underline">Privacy</Link>
          <Link to="/policies/terms" className="link-underline">Terms</Link>
          <Link to="/policies/cookies" className="link-underline">Cookies</Link>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <p className="overline text-muted-foreground">{title}</p>
      <ul className="mt-6 space-y-3">
        {links.map((l) => (
          <li key={l.label}>
            <Link to={l.to} className="text-sm link-underline">{l.label}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
